import React, { useState } from "react";
import "./DimensionsTab.css";
import { useConfiguration } from "src/contexts/ConfigurationContext";
import RadioBlocksExtended from "src/components/Input/RadioBlocksExtended/RadioBlocksExtended";
import SelectUnselectExtended from "src/components/SelectUnselectExtended/SelectUnselectExtended";

export const structureColor = [
  {
    id: 0,
    // name: "JetBlack, RAL 9015",
    name: "Mat zwart - RAL9005MS",
    color: "#2a292a",
    value: "mat_black",
    price: 0,
    carouselImages: [`${process.env.PUBLIC_URL}/images/ral9015.jpg`],
    // description:
    //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  },
  {
    id: 1,
    // name: "PureWhite, RAL 9010",
    name: "Mat crème wit - RAL9001MS",
    color: "#f7f9ef",
    value: "mat_white",
    price: 0,
    carouselImages: [`${process.env.PUBLIC_URL}/images/ral9010.jpg`],
    // description:
    //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  },
  {
    id: 2,
    // name: "Antraciet, RAL 7016",
    name: "Mat antraciet - RAL7016MS",
    color: "#353C40",
    value: "mat_blue",
    price: 0,
    carouselImages: [`${process.env.PUBLIC_URL}/images/ral7039.jpg`],
    // description:
    //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  },
  // {
  //   id: 3,
  //   name: "QuartzGrey, RAL 7039",
  //   color: "#6b665e",
  //   value: "mat_brown",
  //   carouselImages: [`${process.env.PUBLIC_URL}/images/ral7016.jpg`],
  //   description:
  //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  // },
];

const polyShades = [
  {
    id: 0,
    name: "Opaal",
    value: "light",
    price: 0,
    imageUrl: `${process.env.PUBLIC_URL}/images/ver_poly_light.png`,
    // description:
    //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  },
  {
    id: 1,
    name: "Helder",
    value: "mid",
    price: 0,
    imageUrl: `${process.env.PUBLIC_URL}/images/ver_poly_mid.png`,
    // description:
    //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  },
  {
    id: 2,
    name: "Blackline",
    value: "dark",
    price: 0,
    imageUrl: `${process.env.PUBLIC_URL}/images/ver_poly_dark.png`,
    // description:
    //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  },
];

const glassShades = [
  {
    id: 0,
    name: "Helder",
    value: "light",
    color: "#9BFFBE",
    price: 0,
    imageUrl: `${process.env.PUBLIC_URL}/images/ver_glass_light.png`,
    // description:
    //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  },
  {
    id: 1,
    name: "Melk/opaal",
    value: "dark",
    color: "#9BFFBE",
    price: 0,
    imageUrl: `${process.env.PUBLIC_URL}/images/ver_glass_dark.png`,
    // description:
    //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  },
];

const Component: React.FC = () => {
  const { state, setSpy, setRoofGlassMat, setGutter, configuration } =
    useConfiguration();

  const handleGlassChange = (value: string) => {
    if (state.roofGlassMat.glass === value) return;
    if (value === "polywide") {
      setRoofGlassMat({
        ...state.roofGlassMat,
        glass: value,
        polyshade: "mid",
      });
      return;
    }

    setRoofGlassMat({
      ...state.roofGlassMat,
      glass: value,
      glassshade: "light",
    });
  };

  const handleGlassShadeChange = (value: string) => {
    if (state.roofGlassMat.glassshade === value) return;
    setRoofGlassMat({
      ...state.roofGlassMat,
      glassshade: value,
    });
  };

  const handlePolyShadeChange = (value: string) => {
    if (state.roofGlassMat.polyshade === value) return;
    setRoofGlassMat({
      ...state.roofGlassMat,
      polyshade: value,
    });
  };

  const handleGooter = (value: string) => {
    if (state.gutter.type === value) return;
    setGutter({ ...state.gutter, type: value });
  };

  const handleSpyLeftChange = (enabled: boolean) => {
    if (state.spy.left === enabled) return;
    setSpy({ ...state.spy, left: enabled });
  };

  const handleSpyRightChange = (enabled: boolean) => {
    if (state.spy.right === enabled) return;
    setSpy({ ...state.spy, right: enabled });
  };

  // polyShades.map(
  //   (i) =>
  //     (i.price = configuration.calculationService.getGlass(`poly${i.value}`))
  // );

  const polyShadeComponent = () => {
    return (
      <>
        <RadioBlocksExtended
          blocks={polyShades}
          value={state.roofGlassMat.polyshade}
          onChange={handlePolyShadeChange}
          className={"inner_child"}
          parentIsSelected={state.roofGlassMat.glass === "poly"}
        />
      </>
    );
  };

  const glassShadeComponent = () => {
    // glassShades.map(
    //   (i) =>
    //     (i.price = configuration.calculationService.getGlass(`glass${i.value}`))
    // );
    return (
      <>
        {/* <Text content="Glass Shade" /> */}
        <RadioBlocksExtended
          blocks={glassShades}
          value={state.roofGlassMat.glassshade}
          onChange={handleGlassShadeChange}
          className={"inner_child"}
          parentIsSelected={state.roofGlassMat.glass === "glass"}
        />
      </>
    );
  };

  return (
    <>
      {/* <Text content="Glass Material" /> */}
      <RadioBlocksExtended
        blocks={[
          {
            id: 0,
            name: "Glas",
            value: "glass",
            imageUrl: `${process.env.PUBLIC_URL}/images/ver_glass_light.png`,
            component: glassShadeComponent,
            // description:
            //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat
          },
          {
            id: 1,
            name: "Polycarbonaat",
            value: "poly",
            imageUrl: `${process.env.PUBLIC_URL}/images/ver_poly_dark.png`,
            component: polyShadeComponent,
            // description:
            //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          },
          // {
          //   id: 2,
          //   name: "Polycarbonaat Breed",
          //   imageUrl: `${process.env.PUBLIC_URL}/images/ver_poly_wide.png`,
          //   price: configuration.calculationService.getGlass("polywide"),
          //   value: "polywide",
          //   // component: polyShadeComponent,
          //   description:
          //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          // },
        ]}
        value={state.roofGlassMat.glass}
        onChange={handleGlassChange}
        className={"root-type-radio-blocks"}
      />
    </>
  );
};

const DimensionsTab: React.FC = () => {
  const { state, setDimensions, setRoofMaterial } = useConfiguration();

  const handleRoofMaterial = (value: string) => {
    if (state.roofType === value) return;
    setRoofMaterial(value);
  };

  const getGlass = () => {
    const value = state.roofGlassMat;
    const type = value.glass;

    if (type === "glass") {
      return `Glas ${
        glassShades.find((i) => i.value === value.glassshade)?.name
      }`;
    } else if (type === "poly") {
      return `Polycarbonaat ${
        polyShades.find((i) => i.value === value.polyshade)?.name
      }`;
    } else return "Polycarbonaat Breed";

    return "helder";
  };

  const carousel = [
    `${process.env.PUBLIC_URL}/images/ver_mat_black.jpg`,
    `${process.env.PUBLIC_URL}/images/ver_mat_white.jpg`,
    `${process.env.PUBLIC_URL}/images/ver_mat_blue.jpg`,
    `${process.env.PUBLIC_URL}/images/ver_mat_brown.jpg`,
  ];

  return (
    <div className="dimensions-tab">
      <SelectUnselectExtended
        name="Kleur"
        imageUrl={`${process.env.PUBLIC_URL}/images/ver_materials.png`}
        // description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
        isSelected={true}
        onSelect={() => true}
        onUnselect={() => false}
        alwaysShowSelected={true}
        carouselImages={carousel}
        Component={() => (
          <RadioBlocksExtended
            blocks={structureColor}
            value={state.roofMaterial}
            onChange={handleRoofMaterial}
            className={"inner_child"}
          />
        )}
        selectedNames={`${
          structureColor.find((i) => i.value === state.roofMaterial)?.name
        }`}
      />

      <SelectUnselectExtended
        name="Dakmateriaal"
        imageUrl={`${process.env.PUBLIC_URL}/images/ver_glass_light.png`}
        // description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
        isSelected={true}
        onSelect={() => true}
        onUnselect={() => false}
        alwaysShowSelected={true}
        Component={Component}
        selectedNames={getGlass()}
      />
    </div>
  );
};

export default DimensionsTab;
